import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../utils/AuthContext';

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://expensetracker-yj7e.onrender.com/api/register', { username, password });
      login(res.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response.data.message || 'Registration failed');
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-white p-4">
        <form onSubmit={handleSubmit} className="p-8 bg-white rounded-2xl shadow-2xl border border-gray-300 w-full max-w-md transition duration-300 ease-in-out transform hover:scale-105">
          <h2 className="text-4xl mb-8 text-center text-gray-800">Join ExpenseTracker</h2>
          {error && <p className="text-red-600 text-center mb-6 text-base font-medium bg-red-100 bg-opacity-70 p-3 rounded-lg border border-red-400 animate-pulse">{error}</p>}
          <div className="mb-6">
            <label className="block text-gray-700 text-lg mb-2" htmlFor="username">
              Username
            </label>
            <input
              type="text"
              id="username"
              className="shadow-sm appearance-none border border-gray-400 rounded-lg w-full py-3 px-4 text-gray-900 bg-gray-50 leading-tight focus:outline-none focus:ring-3 focus:ring-blue-300 focus:border-transparent transition duration-300 ease-in-out placeholder-gray-500 text-base"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Enter your username"
            />
          </div>
          <div className="mb-8">
            <label className="block text-gray-700 text-lg mb-2" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="shadow-sm appearance-none border border-gray-400 rounded-lg w-full py-3 px-4 text-gray-900 bg-gray-50 leading-tight focus:outline-none focus:ring-3 focus:ring-blue-300 focus:border-transparent transition duration-300 ease-in-out placeholder-gray-500 text-base"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between mt-8 space-y-4 sm:space-y-0">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 w-full sm:w-auto transform hover:scale-105"
            >
              Register
            </button>
            <Link to="/login" className="inline-block align-baseline text-blue-600 hover:text-blue-800 transition duration-300 ease-in-out text-base">
              Already have an account? <span className="underline">Login</span>
            </Link>
          </div>
        </form>
      </div>
    </>
  );
};

export default Register;
